import { permissionObj } from "../../../../Helpers/permission"
import {TAB_OPTIONS} from '../TrafficFines/Model/Model';
import {STATUS_MODEL} from '../../../../enums/statusEnum';
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 */

// Constants that define the available tabs in the Traffic Fine System module.
export const TABS_TRAFFIC = {

    TRAFFIC_FINES: {
        INDEX: 0,
        TRANS: "traffic_fines",
    },
    MANAGE: {
        INDEX: 1,
        TRANS: "manage",
    },
    FINES_TYPES: {
        INDEX: 2,
        TRANS: "fine_types",
    },
}

// Constants that define the possible subviews for each tab in the Traffic Fine System module.
export const TRAFFIC_SUB_VIEW_MODEL = {
    TRAFFIC_FINES: {
        DASHBOARD: "DASHBOARD",
        USERS: "USERS"
    },
    MANAGE: {
        FINES: 'FINES',
        GEOFENCES: 'GEOFENCES',
    },
}
// Function that maps permissions to each tab and subview of the Traffic module
export function TAB_PERMISSION_TRAFFIC (subView, innerView){
    let showExport = null;
    if(subView === TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.DASHBOARD)
        showExport = innerView === TAB_OPTIONS.FINES ? permissionObj?.WEB_TRAFFIC_DASHBOARD_FINES_EXPORT : null;
    else if(subView === TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.USERS)
        showExport = permissionObj?.WEB_TRAFFIC_USERS_EXPORT;

    return {
        CREATE: {
            [TABS_TRAFFIC.TRAFFIC_FINES.INDEX]:
                subView === TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.DASHBOARD && innerView === TAB_OPTIONS.FINES
                    ? permissionObj?.WEB_TRAFFIC_DASHBOARD_FINES_CREATE
                    : null,

            [TABS_TRAFFIC.FINES_TYPES.INDEX]: permissionObj?.WEB_FINE_TYPE_CREATE,

            [TABS_TRAFFIC.MANAGE.INDEX]:
                subView === TRAFFIC_SUB_VIEW_MODEL.MANAGE.GEOFENCES
                    ? permissionObj?.WEB_TRAFFIC_MANAGE_GEOFENCES_CREATE
                    : null,
        },
        DELETE: {
            [TABS_TRAFFIC.FINES_TYPES.INDEX]: permissionObj?.WEB_FINE_TYPE_DELETE,
            [TABS_TRAFFIC.MANAGE.INDEX]: null
        },
        UPDATE: {
             [TABS_TRAFFIC.MANAGE.INDEX]:
                subView === TRAFFIC_SUB_VIEW_MODEL.MANAGE.FINES
                     ? permissionObj?.WEB_TRAFFIC_MANAGE_FINES_UPDATE
                     : null
        },
        EXPORT: {
            [TABS_TRAFFIC.TRAFFIC_FINES.INDEX]:showExport,
            [TABS_TRAFFIC.FINES_TYPES.INDEX]: null,
            [TABS_TRAFFIC.MANAGE.INDEX]: null,
        },
    }
}

export const MODEL_MAP_TYPE ={
    SATELLITE:'satellite',
    MAP:'map'
}

export const getItemStatusFines = (item) => {
    const statusId = parseInt(item?.statusScheduleId) === STATUS_MODEL.OVERDUE && parseInt(item?.statusId) ===STATUS_MODEL.ISSUED
        ? item?.statusScheduleId
        : item?.statusId;

    return statusId;
}
